import { SectionNotEnabledState } from '@/shared/components/section-not-enabled/section-not-enabled-state';

export function BranchSubscriptionExpiredState() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <SectionNotEnabledState
        translationPrefix="subscription.expired"
        fillHeight
      />
    </div>
  );
}
